"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultEditorTheme = void 0;
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const mui_rte_1 = __importDefault(require("mui-rte"));
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const formik_1 = require("formik");
const draft_js_1 = require("draft-js");
const lodash_1 = require("lodash");
exports.defaultEditorTheme = (0, styles_1.createMuiTheme)();
Object.assign(exports.defaultEditorTheme, {
    overrides: {
        MUIRichTextEditor: {
            root: {
                height: '100%',
            },
            container: {
                display: 'flex',
                flexDirection: 'column-reverse',
                height: '100%',
                '& div:nth-child(2)': {
                    width: '100%',
                    height: 'calc(100% - 16px)',
                },
            },
            editor: {
                paddingLeft: 10,
                overflowY: 'auto',
                height: '100%',
            },
            toolbar: {
                backgroundColor: 'rgba(17,15,36,0.2)',
                marginBottom: 8,
                borderBottomRightRadius: '4px',
                borderBottomLeftRadius: '4px',
            },
            placeHolder: {
                paddingLeft: 10,
                width: 'inherit',
                position: 'absolute',
                top: 0,
            },
        },
    },
});
const useStyles = (0, styles_1.makeStyles)((theme) => ({
    editorContainer: {
        flex: 1,
        position: 'relative',
    },
    icon: {
        cursor: 'pointer',
        position: 'absolute',
        right: 0,
        bottom: 0,
        opacity: 0.5,
    },
    readOnlyText: {
        '& p': {
            fontSize: '1rem',
            lineHeight: '16px',
        },
    },
    inputLabel: {
        color: theme.palette.primary.main,
        pointerEvents: 'none',
        fontSize: '14px',
        marginLeft: '8px',
        fontWeight: 400,
    },
}));
const RenderRichTextField = (props) => {
    const { field: { value, name }, form: { touched, errors, setFieldValue, setFieldTouched, submitCount, initialValues }, fieldLabel, placeholder, controls, defaultValue, allwaysOpen, onClick = () => undefined, ...otherProps } = props;
    const classes = useStyles();
    const error = (0, formik_1.getIn)(errors, name);
    const touch = (0, formik_1.getIn)(touched, name);
    const [editMode, switchEditMode] = (0, react_1.useState)(allwaysOpen);
    // Ensure initialValue is always a JSON string for MUIRichTextEditor
    const getInitialValue = (val) => {
        if (!val)
            return defaultValue;
        if (typeof val === 'string')
            return val;
        // If it's an object, stringify it
        return JSON.stringify(val);
    };
    const initialValue = (0, react_1.useRef)(getInitialValue(value));
    const displayErrors = (touch || submitCount > 0) && !!error;
    (0, react_1.useEffect)(() => {
        initialValue.current = getInitialValue(initialValues[name]);
    }, [initialValues[name]]);
    (0, react_1.useEffect)(() => {
        if (!editMode) {
            initialValue.current = getInitialValue(value);
        }
        else {
            setFieldTouched(name, true);
            onClick();
        }
    }, [editMode]);
    const debouncedSetFieldValue = (0, lodash_1.debounce)((value) => setFieldValue(name, value), 250);
    const onValueChange = (state) => {
        try {
            if (!state || typeof state.getCurrentContent !== 'function') {
                console.warn('Invalid editor state received');
                return;
            }
            const contentState = state.getCurrentContent();
            if (!contentState || typeof contentState.getBlockMap !== 'function') {
                console.warn('Invalid content state');
                return;
            }
            const rawContent = (0, draft_js_1.convertToRaw)(contentState);
            // Save as JSON string since that's what the backend expects to parse
            debouncedSetFieldValue(JSON.stringify(rawContent));
        }
        catch (error) {
            console.error('Error converting editor state:', error);
            // Continue without updating to prevent crashes
        }
    };
    const onEditorBlur = () => {
        if (!allwaysOpen) {
            switchEditMode(false);
        }
        setFieldTouched(name, true);
        onClick();
    };
    const onEditorFocus = () => {
        switchEditMode(true);
    };
    return (react_1.default.createElement(core_1.Box, { onClick: () => switchEditMode(true), className: classes.editorContainer },
        react_1.default.createElement(styles_1.MuiThemeProvider, { theme: exports.defaultEditorTheme },
            react_1.default.createElement(mui_rte_1.default, { error: touch && !!error, label: placeholder, defaultValue: initialValue.current, controls: editMode ? controls : [], onChange: (state) => onValueChange(state), onBlur: () => onEditorBlur(), onFocus: () => onEditorFocus(), readOnly: !editMode, inlineToolbar: false, ...otherProps })),
        displayErrors && (react_1.default.createElement(core_1.Box, { className: "mb-1" },
            react_1.default.createElement(core_1.Typography, { variant: "body2", component: "p", color: "error", ...otherProps }, error)))));
};
RenderRichTextField.propTypes = {
    field: prop_types_1.default.any.isRequired,
    form: prop_types_1.default.any.isRequired,
    fieldLabel: prop_types_1.default.string,
    placeholder: prop_types_1.default.string,
    controls: prop_types_1.default.array,
    defaultValue: prop_types_1.default.any,
    allwaysOpen: prop_types_1.default.bool,
    onClick: prop_types_1.default.func,
};
RenderRichTextField.defaultProps = {
    fieldLabel: '',
    placeholder: '',
    defaultValue: JSON.stringify((0, draft_js_1.convertToRaw)(draft_js_1.EditorState.createEmpty().getCurrentContent())),
    allwaysOpen: false,
};
exports.default = RenderRichTextField;
